var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-previews" },
    _vm._l(_vm.moduleList, function(modules) {
      return _c("div", { key: modules.moduleId }, [
        _c("h2", { staticClass: "module-name" }, [
          _vm.showSubmit
            ? _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.$emit("nextStep", 2)
                    }
                  }
                },
                [
                  _c("a-icon", { attrs: { type: "edit" } }),
                  _vm._v(" 修改信息")
                ],
                1
              )
            : _vm._e(),
          _c("b"),
          _vm._v(_vm._s(modules.moduleName) + "\n    ")
        ]),
        _vm._v(" "),
        _vm.$route.path == "/infoDetail" || _vm.$route.path == "/myBrand"
          ? _c(
              "table",
              { staticClass: "data-preparation-list" },
              _vm._l(modules.columns, function(list) {
                return _c("tr", { key: list.id }, [
                  _c("td", { staticClass: "upload-files-label" }, [
                    _vm._v(_vm._s(list.keyLabel))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "upload-files-item" }, [
                    list.keyName == "trademarkCategory"
                      ? _c(
                          "div",
                          { staticClass: "trademarkCategory-box" },
                          _vm._l(JSON.parse(list.keyNameValue), function(
                            item,
                            index
                          ) {
                            return _c(
                              "table",
                              { key: item.category1Num },
                              [
                                _c(
                                  "tr",
                                  { staticClass: "trademarkCategory-head" },
                                  [
                                    _c("td", { attrs: { width: "110" } }, [
                                      _vm._v("大类" + _vm._s(index + 1))
                                    ]),
                                    _vm._v(" "),
                                    _vm.countryCode === "JP"
                                      ? _c("td", { attrs: { colspan: 5 } }, [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(item.category1Name) +
                                              "\n                "
                                          )
                                        ])
                                      : _c(
                                          "td",
                                          {
                                            attrs: {
                                              colspan: ["DE", "KR"].includes(
                                                _vm.countryCode
                                              )
                                                ? 4
                                                : _vm.countryCode === "CN"
                                                ? 2
                                                : 3
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.category1Name) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(item.listTrademarkCategory2, function(
                                  sub,
                                  index
                                ) {
                                  return _c("tr", { key: sub.category2Num }, [
                                    index == 0
                                      ? _c(
                                          "td",
                                          {
                                            attrs: {
                                              rowspan:
                                                item.listTrademarkCategory2
                                                  .length
                                            }
                                          },
                                          [_vm._v("小类")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(index + 1))]),
                                    _vm._v(" "),
                                    sub.category2Name
                                      ? _c("td", [
                                          _vm._v(_vm._s(sub.category2Name))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.countryCode !== "CN"
                                      ? _c("td", [
                                          _vm._v(_vm._s(sub.category2NameEn))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ["DE", "KR"].includes(_vm.countryCode)
                                      ? _c("td", [
                                          _vm._v(_vm._s(sub.categoryNameMore))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.countryCode === "JP"
                                      ? _c("td", [
                                          _vm._v(_vm._s(sub.categoryNameJp))
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.countryCode === "JP"
                                      ? _c("td", [
                                          _vm._v(_vm._s(sub.similarGroup))
                                        ])
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            )
                          }),
                          0
                        )
                      : list.keyName == "marketHref" &&
                        JSON.stringify(list.keyNameValue) !== "{}"
                      ? _c(
                          "div",
                          _vm._l(JSON.parse(list.keyNameValue), function(
                            item,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "marketHref-category"
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.marketHref) +
                                    "\n              "
                                ),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(item.category2Name) +
                                      "-" +
                                      _vm._s(item.category2NameEn)
                                  )
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : list.keyName == "useProductImg"
                      ? _c(
                          "div",
                          _vm._l(_vm.useProductImgList, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "marketHref-category"
                              },
                              [
                                _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: item.fileList }
                                  },
                                  [
                                    _vm._l(item.fileList, function(src, index) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(item.category2Name) +
                                      "-" +
                                      _vm._s(item.category2NameEn)
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : list.keyName == "useEvidence"
                      ? _c(
                          "div",
                          _vm._l(_vm.useEvidenceList, function(item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "marketHref-category"
                              },
                              [
                                _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: item.fileList }
                                  },
                                  [
                                    _vm._l(item.fileList, function(src, index) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(item.category2Name) +
                                      "-" +
                                      _vm._s(item.category2NameEn)
                                  )
                                ])
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : ["firstUseDate", "firstBusinessUseDate"].includes(
                          list.keyName
                        )
                      ? _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                list.keyNameValue &&
                                  JSON.stringify(list.keyNameValue) !== "{}" &&
                                  list.keyNameValue.split(" ")[0]
                              ) +
                              "\n          "
                          )
                        ])
                      : list.inputType == 4 ||
                        list.keyName == "companyLegalPersonSign"
                      ? _c(
                          "div",
                          [
                            Array.isArray(list.keyNameValue)
                              ? _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: list.keyNameValue }
                                  },
                                  [
                                    _vm._l(list.keyNameValue, function(
                                      src,
                                      index
                                    ) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : list.keyNameValue &&
                                JSON.stringify(list.keyNameValue) !== "{}"
                              ? _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: [list.keyNameValue] }
                                  },
                                  [
                                    _vm._l([list.keyNameValue], function(
                                      src,
                                      index
                                    ) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : list.inputType == 2
                      ? _c("div", [_vm._v(_vm._s(_vm.getValue2(list)))])
                      : list.inputType == 1 ||
                        list.inputType == 5 ||
                        list.inputType == 6 ||
                        list.inputType == 8
                      ? _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(list.keyNameValue) +
                              "\n          "
                          )
                        ])
                      : _c("div", [_vm._v(_vm._s(list.keyLabel))])
                  ])
                ])
              }),
              0
            )
          : _c(
              "table",
              { staticClass: "data-preparation-list" },
              _vm._l(modules.columns, function(list) {
                return _c("tr", { key: list.id }, [
                  _c("td", { staticClass: "upload-files-label" }, [
                    _vm._v(_vm._s(list.keyLabel))
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "upload-files-item" }, [
                    list.keyName == "modelingFile"
                      ? _c(
                          "div",
                          _vm._l(list.reView, function(src, index) {
                            return _c(
                              "a",
                              {
                                key: index,
                                attrs: { href: src, target: "_blank" }
                              },
                              [_vm._v("查看文件")]
                            )
                          }),
                          0
                        )
                      : list.keyName == "drawingFile"
                      ? _c(
                          "div",
                          _vm._l(list.reView, function(src, index) {
                            return _c(
                              "a",
                              {
                                key: index,
                                attrs: { href: src, target: "_blank" }
                              },
                              [_vm._v("查看文件")]
                            )
                          }),
                          0
                        )
                      : list.reViewValue
                      ? _c("div", [_vm._v(_vm._s(list.reViewValue))])
                      : list.inputType == 1 ||
                        list.inputType == 6 ||
                        list.inputType == 8
                      ? _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(list.reView) +
                              "\n          "
                          )
                        ])
                      : list.inputType == 4
                      ? _c(
                          "div",
                          [
                            Array.isArray(list.reView)
                              ? _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: list.reView }
                                  },
                                  [
                                    _vm._l(list.reView, function(src, index) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : list.reView
                              ? _c(
                                  "viewer",
                                  {
                                    staticStyle: { width: "200px" },
                                    attrs: { images: [list.reView] }
                                  },
                                  [
                                    _vm._l([list.reView], function(src, index) {
                                      return [
                                        src.includes("png") ||
                                        src.includes("jpg") ||
                                        src.includes("jpeg") ||
                                        src.includes("bmp") ||
                                        src.includes("PNG") ||
                                        src.includes("JPG") ||
                                        src.includes("JPEG") ||
                                        src.includes("BMP")
                                          ? _c("img", {
                                              key: index,
                                              staticClass: "module-img",
                                              attrs: { src: src }
                                            })
                                          : _c(
                                              "a",
                                              {
                                                key: index,
                                                staticClass: "fileModel-other",
                                                attrs: {
                                                  href: src,
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.fileModelUrlSuffix(
                                                        src
                                                      )
                                                    ) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                      ]
                                    })
                                  ],
                                  2
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _c("div", [_vm._v(_vm._s(list.keyLabel))])
                  ])
                ])
              }),
              0
            )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c3ffde", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c3ffde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/dataPreviews.vue
// module id = null
// module chunks = 